import React, { useCallback, useEffect, useContext } from 'react';
import { IEditForm } from '../../types/interfaces/IEditForm';
import { TextField, Typography, Box, IconButton } from '@material-ui/core';
import AutorenewRoundedIcon from '@material-ui/icons/AutorenewRounded';
import FileCopyRoundedIcon from '@material-ui/icons/FileCopyRounded';
import generatePassword from 'password-generator';
import { SnackMessageContext } from '../../contexts/snackMessage/SnackMessageContext';

const CreatePasswordField: React.FC<IEditForm> = ({ onChange, value, fieldName, multiline, label }) => {
  const { push } = useContext(SnackMessageContext);

  const handleOnChange = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
      onChange ? onChange(fieldName, event.target.value) : () => null,
    [fieldName, onChange],
  );

  const handleOnClickCopy = useCallback(() => {
    navigator.clipboard.writeText(value?.toString());
    push({ title: 'Copied!', message: 'Password copied to clipboard' });
  }, [push, value]);

  const handleOnClickGenerate = useCallback(() => {
    if (onChange) {
      onChange(fieldName, generatePassword(12, false));
      handleOnClickCopy();
    }
  }, [fieldName, handleOnClickCopy, onChange]);

  useEffect(() => {
    if (onChange) {
      onChange(fieldName, generatePassword(12, false));
    }
  }, [fieldName]);

  return (
    <>
      <Typography variant="h6">{label}</Typography>
      <Box display="flex">
        <Box display="flex" flexDirection="column" width={'100%'}>
          <TextField
            id={fieldName}
            name={fieldName}
            onChange={handleOnChange}
            value={value?.toString()}
            multiline={multiline}
            rows={multiline ? 6 : 1}
            style={{ width: 'auto' }}
          />
        </Box>

        <IconButton color="primary" onClick={handleOnClickGenerate}>
          <AutorenewRoundedIcon />
        </IconButton>
        <IconButton onClick={handleOnClickCopy}>
          <FileCopyRoundedIcon color="secondary" />
        </IconButton>
      </Box>
    </>
  );
};

export default CreatePasswordField;
